const DOMAIN = "api.cheque-app.multixdev.ir";
// const DOMAIN = "91.107.250.116:10000";

export const HOST = `https://${DOMAIN}`;
export const WS_HOST = `wss://${DOMAIN}/ws`;

export const HOST_USER_FILES = `${HOST}/user/file`;
export const HOST_CHEQUE_FILES = `${HOST}/cheque/file`;
export const HOST_CASH_FILES = `${HOST}/cash/file`;
export const HOST_CHAT_FILES = `${HOST}/message/file`;

export const DEBUG = false;
